@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <div class='text-list-input-container'>
      <label>
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </label>
      <div class="fx-column fx-justify-start fx-items-stretch">
        @for (item of list; track trackByFn(i, item); let i = $index) {
          <div>
            <div class="fx-row fx-justify-space-between fx-items-center">
              <div class="fx-flex fx-column fx-justify-start fx-items-stretch">
                <mat-form-field>
                  <input [readonly]='inputService.inputConfig.readOnly' [placeholder]="'Titolo' | translate" matInput autocomplete="off" [name]='inputService.formControlKey + "text_input_item_" + i + "_0"' [(ngModel)]='list[i][0]' [ngModelOptions]="{standalone: true}"/>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>{{'Breve Descrizione' | translate}}</mat-label>
                  <textarea [readonly]='inputService.inputConfig.readOnly' matInput autocomplete="off" [name]='inputService.formControlKey + "text_input_item_" + i + "_0"' [(ngModel)]='list[i][1]' [ngModelOptions]="{standalone: true}">
                  </textarea>
                </mat-form-field>
              </div>
              @if (!inputService.inputConfig.readOnly) {
                <button mat-icon-button color='warn' (click)="removeItem(i)">
                  <span class="material-icons">close</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
      @if (!inputService.inputConfig.readOnly) {
        <button mat-button color='accent' (click)='addNewItem()'>{{'Aggiungi' | translate}}</button>
      }
    </div>
  </ng-container>
}